import React from 'react'
import Slider from '../../components/Slider/Slider';
import Aboutus from '../../components/Aboutus/Aboutus';
import Customers from '../../components/customers/customers';
import Owner from '../../components/owner/Owner';
import Service from '../../components/Service/Service';


function Home() {
  return (
    <div>
      <Slider/>
      <Aboutus/>
      <Customers/>
      <Owner/>
      <Service/>
      
      
    </div>
  )
}

export default Home
